import { TestIdsPages } from '#app/shared/components/TestIdsPages';
import { Button } from '#app/shared/components/ui/button';
import { StatusPage } from './StatusPage';

type SignOutButtonProps = {
  onClick: () => void;
};

export const SignOutButton: React.FC<SignOutButtonProps> = ({
  onClick: onSignOut,
}) => {
  return (
    <Button variant="outline" onClick={onSignOut}>
      Sign out
    </Button>
  );
};

type IncorrectAccountTypePageProps = {
  onSignOut: () => void;
};
export const IncorrectAccountTypeStatusPage: React.FC<
  IncorrectAccountTypePageProps
> = ({ onSignOut }) => {
  return (
    <StatusPage
      data-testid={TestIdsPages.IncorrectAccountTypePage}
      title="Incorrect Account Type"
      subtitle="Your account is not the correct type to access this application."
      action={<SignOutButton onClick={onSignOut} />}
    />
  );
};
